import { PolicyConfiguration, PolicyLimitConfiguration, POLICY_TYPE, POLICY_LIMIT_TYPE } from "./policy-configuration";
import * as _ from "lodash";
import moment from "moment";
import "moment-timezone";

export class BookingHoursPolicy extends PolicyConfiguration {
  constructor(identifier, policyLevel) {
    super(identifier, POLICY_TYPE.BookingHours, policyLevel);

    this.limits = [];
  }

  toString() {
    let limitsString = 'No limits';
    if (this.limits && this.limits.length > 0) {
      limitsString = this.limits
        .map(bhpl => bhpl.toString())
        .join(', ');
    }
    return `${POLICY_TYPE.nameof(this.policyType)} (${limitsString})`;
  }

  isValid() {
    let isValid = !!this.identifier && !!this.identifier.trim();
    if (this.limits && this.limits.length > 0) {
      isValid = isValid && this.limits
        .every(l => l.isValid());
    }
    return isValid;
  }

  static fromJSON(json) {
    if (!json) return undefined;

    let policy = Object.assign(new BookingHoursPolicy(), json);
    if (policy.limits) {
      policy.limits = policy.limits.map(l => {
        return BookingHoursPolicyLimit.fromJSON(l);
      })
    }

    return policy;
  }
}

export class BookingHoursPolicyLimit extends PolicyLimitConfiguration {
  constructor(limitType, bookingAllowedFrom, bookingAllowedUntil, target) {
    super('BookingHoursPolicyLimitConfiguration', limitType);

    this.bookingAllowedFrom = bookingAllowedFrom;
    this.bookingAllowedUntil = bookingAllowedUntil;
    this.target = target;
  }

  static fromJSON(json) {
    if (!json) return undefined;

    return Object.assign(new BookingHoursPolicyLimit(), json);
  }

  toString() {
    return `${POLICY_LIMIT_TYPE.nameof(this.limitType)}: allowed from ${this.formatBookingAllowedFromTime()} to ${this.formatBookingAllowedUntilTime()} relative to ${BOOKING_HOURS_RELATIVE_TARGET.nameof(this.target)}`;
  }

  isValid() {
    const bookingAllowedFromIsValid =
      !this.bookingAllowedFrom || (
        !!this.bookingAllowedFrom.trim() && _.split(this.bookingAllowedFrom, ':').length > 1);

    const bookingAllowedUntilIsValid =
      !this.bookingAllowedUntil || (
        !!this.bookingAllowedUntil.trim() && _.split(this.bookingAllowedUntil, ':').length > 1);

    const relativeToIsValid = this.target === BOOKING_HOURS_RELATIVE_TARGET.OpeningTime ||
      this.target === BOOKING_HOURS_RELATIVE_TARGET.ClosingTime;

    let timesAreValid = true;
    if (!!this.bookingAllowedFrom && !!this.bookingAllowedUntil) {
      const momentFrom = moment.duration(this.bookingAllowedFrom);
      const momentUntil = moment.duration(this.bookingAllowedUntil);
      timesAreValid = momentFrom.as('milliseconds') < momentUntil.as('milliseconds');
    }

    return bookingAllowedFromIsValid && bookingAllowedUntilIsValid && relativeToIsValid && timesAreValid;
  }

  formatBookingAllowedFromTime() {
    if (!this.bookingAllowedFrom) return 'Always';
    return this.getHoursMinutesString(this.bookingAllowedFrom) + ' hours before';
  }

  formatBookingAllowedUntilTime() {
    if (!this.bookingAllowedUntil) return 'Exact time';
    return this.getHoursMinutesString(this.bookingAllowedUntil) + ' hours before';
  }

  getHoursMinutesString(timespanString) {
    const momentDuration = moment.duration(timespanString);
    const hours = _.padStart(Math.abs(momentDuration.hours()), 2, '0');
    const minutes = _.padStart(Math.abs(momentDuration.minutes()), 2, '0');
    return `${hours}:${minutes}`
  }
}

export class BOOKING_HOURS_RELATIVE_TARGET {
  static OpeningTime = 0;
  static ClosingTime = 1;

  static nameof(target) {
    switch (target) {
      case BOOKING_HOURS_RELATIVE_TARGET.OpeningTime: {
        return "Opening time";
      }
      case BOOKING_HOURS_RELATIVE_TARGET.ClosingTime: {
        return "Closing time";
      }
    }
  }
}


